import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './webstoreUserOrders.scss';

const API_BASE_URL =
  process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_API_URL_PRODUCTION
    : process.env.REACT_APP_API_URL;

const WebstoreUserOrders = ({ user }) => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.email) return;

    const fetchOrders = async () => {
      try {
        const res = await axios.get(
          `${API_BASE_URL}/api/webstore-orders/my-orders?email=${user.email}`
        );
        setOrders(res.data.orders);
      } catch (err) {
        console.error('Failed to fetch user orders', err);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [user]);

  const handleCancel = async (orderId) => {
    if (!window.confirm('Are you sure you want to cancel this order?')) return;

    try {
      await axios.post(`${API_BASE_URL}/api/webstore-orders/cancel`, { orderId });
      setOrders((prev) =>
        prev.map((order) =>
          order._id === orderId ? { ...order, status: 'cancelled' } : order
        )
      );
    } catch (err) {
      console.error('Cancellation failed', err);
    }
  };

  if (!user) return <p className="order-placeholder">Please log in to view your orders.</p>;
  if (loading) return <p className="order-placeholder">Loading your orders...</p>;
  if (orders.length === 0) return <p className="order-placeholder">You haven’t placed any orders yet.</p>;

  return (
    <div className="user-orders">
      <h2>Your Orders</h2>
      <ul className="order-list">
        {orders.map((order) => (
          <li key={order._id} className="order-card">
            <div className="order-top">
              <div>
                <p><span>Order ID:</span> {order._id}</p>
                <p><span>Total:</span> ₱{order.total.toFixed(2)}</p>
                <p><span>Status:</span> <span className={`status-badge ${order.status}`}>{order.status || 'pending'}</span></p>
                <p><span>Payment:</span> {order.paymentMethod || 'NJ Credits'}</p>
                <p><span>Delivery Time:</span> {order.deliveryTime || 3} days</p>
              </div>
              <div className="placed-on">
                <p><span>Placed on:</span><br />{new Date(order.createdAt).toLocaleString()}</p>
              </div>
            </div>

            <ul className="item-list">
              {order.items.map((item, idx) => (
                <li key={idx}>{item.title} – ₱{item.price.toFixed(2)}</li>
              ))}
            </ul>

            {order.note && (
              <div className="order-note">
                <strong>Note:</strong> {order.note}
              </div>
            )}

            {order.status === 'pending' && (
              <button className="cancel-btn" onClick={() => handleCancel(order._id)}>
                Cancel Order
              </button>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default WebstoreUserOrders;
